<template style="height: 100%">
  <article class="message menuInter">
    <div class="message-body">
      <div class="has-text-right">
        <button class="delete" aria-label="delete" v-on:click="close"></button>
      </div>
      <!-- First part -->
      <div class="has-text-centered">
        <!-- Title -->
        <div v-if="data.title">
          <div
            class="heading is-size-6 border"
            :class="titleBg"
            style="padding-top: 5px; margin-top: 15px; text-transform: capitalize;"
          >
            <!-- Text -->
            <div class="is-size-4">{{ data.title }}</div>
          </div>
        </div>
        <br />
        <!-- Graph -->
        <div style="margin: 0px !important; width: 100%" v-if="graph">
          <y-graph
            :datagraph="graph"
            :cambio="cambio"
            style="height: 65px !important;"
          ></y-graph>
        </div>
      </div>
      <br /><br />
      <!-- Info -->
      <div v-if="data.group">
        <!-- Definition -->
        <div
          v-if="
            interpretations[data.group] && interpretations[data.group]['def']
          "
        >
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">book</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Definición
              </p>
              <div class="card-header-icon" v-on:click="switchElement('def')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.def ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <p v-if="elements.def" class="has-text-justified">
              {{ interpretations[data.group]["def"] }}
            </p>
          </transition>
        </div>
        <br />
        <!-- Priorization -->
        <div
          v-if="
            titleBg !== 'bg-sinrango' &&
              interpretations[data.group] &&
              interpretations[data.group]['prt'][titleBg.split('-')[1]]
          "
        >
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">format_list_numbered</i>
              </div>
              <p
                class="card-header-title  is-size-5 has-text-weight-bold is-justify-center"
                :class="titleBg"
              >
                Prioridad - {{ titleBg.split("-")[1] }}
              </p>
              <div class="card-header-icon" v-on:click="switchElement('prt')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.prt ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <div v-if="elements.prt">
              <br />
              <h6 class="is-size-6 has-text-weight-bold">Interpretación</h6>
              <p>
                {{
                  interpretations[data.group]["prt"][titleBg.split("-")[1]]["i"]
                }}
              </p>
              <br />
              <h6 class="is-size-6 has-text-weight-bold">Meta</h6>
              <p>
                {{
                  titleBg.split("-")[1] === "alta"
                    ? getMeta(
                        interpretations[data.group]["prt"][
                          titleBg.split("-")[1]
                        ]["m"]
                      )
                    : interpretations[data.group]["prt"][titleBg.split("-")[1]][
                        "m"
                      ]
                }}
              </p>
            </div>
          </transition>
        </div>
        <br />
        <!-- Risk -->
        <div
          v-if="interpretations[data.group] && interpretations[data.group]['r']"
        >
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">error_outline</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                ¿Cuando es un riesgo?
              </p>
              <div class="card-header-icon" v-on:click="switchElement('r')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.r ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <div v-if="elements.r">
              <ul style="padding: 0 1.5em">
                <li
                  v-for="(r, k) in deleteEmptyElements(
                    interpretations[data.group]['r'].split('-')
                  )"
                  :key="k"
                >
                  <span v-if="r !== '' && r !== null" style="width: 100%">
                    {{ r }}
                  </span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
        <br />
        <!-- Practices -->
        <div
          v-if="interpretations[data.group] && interpretations[data.group]['p']"
        >
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">format_list_numbered </i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Prácticas Exitosas
              </p>
              <div class="card-header-icon" v-on:click="switchElement('p')">
                <span class="icon">
                  <i class="material-icons">{{
                    elements.p ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <div v-if="elements.p">
              <ul style="padding: 0 1.5em">
                <li
                  v-for="(p, k) in deleteEmptyElements(
                    interpretations[data.group]['p'].split('-')
                  )"
                  :key="k"
                >
                  <span v-if="p" style="width: 100%">
                    {{ p }}
                  </span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
        <br />
        <!-- Acciones R -->
        <div
          v-if="
            interpretations[data.group] &&
              interpretations[data.group]['accionesRMM']
          "
        >
          <div class="card">
            <header class="card-header">
              <div class="card-header-icon">
                <i class="material-icons">import_contacts</i>
              </div>
              <p
                class="card-header-title has-text-centered is-size-5 has-text-weight-bold is-justify-center"
              >
                Acciones recomendadas en los manuales del Ministerio
              </p>
              <div
                class="card-header-icon"
                v-on:click="switchElement('accionesRMM')"
              >
                <span class="icon">
                  <i class="material-icons">{{
                    elements.accionesRMM
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"
                  }}</i>
                </span>
              </div>
            </header>
          </div>
          <br />
          <transition name="fade">
            <div v-if="elements.accionesRMM">
              <ul style="padding: 0 1.5em">
                <li
                  v-for="(a, k) in deleteEmptyElements(
                    interpretations[data.group]['accionesRMM'].split('-')
                  )"
                  :key="k"
                >
                  <span v-if="a" style="width: 100%">
                    {{ a }}
                  </span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import yGraph from "../../dashboard/GraphFrs.vue";
import json from "../interpretaciones.json";

export default {
  components: {
    yGraph,
  },
  data() {
    return {
      cambio: 1,
      graph: null,
      titleBg: "bg-sinrango",
      porcentageG: 0,
      interpretations: json,
      elements: {
        def: true,
        prt: true,
        r: true,
        p: true,
        accionesRMM: true,
      },
    };
  },
  methods: {
    createDataGraphHorizontalBar() {
      const data = this.data.data;
      const label = this.data.title;

      if (data && label) {
        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 100,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animate: {},
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
              },
            },
          },
          data: {
            labels: ["Data 1"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28],
                backgroundColor: ["#f4cdcd"],
              },
              {
                label: "Dataset 2",
                data: [45.7],
                backgroundColor: ["#facca5"],
              },
              {
                label: "Dataset 3",
                data: [65.9],
                backgroundColor: ["#fff2cc"],
              },
              {
                label: "Dataset 4",
                data: [72.4],
                backgroundColor: ["#d9ead3"],
              },
              {
                label: "Dataset 5",
                data: [32],
                backgroundColor: ["#c8d9f7"],
              },
            ],
          },
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        let datasets = [];
        // Función que ordena la data a un formato fijo
        const orderData = (p, d) => {
          const postion = (df) => {
            datasets[df] = d;
          };

          switch (p) {
            case "Riesgo muy alto":
              postion(0);
              break;
            case "Riesgo alto":
              postion(1);
              break;
            case "Riesgo medio":
              postion(2);
              break;
            case "Riesgo bajo":
              postion(3);
              break;
            case "Sin riesgo o riesgo despreciable":
              postion(4);
              break;
            case "Sin riesgo o riesgo bajo":
              postion(5);
              break;
            case "Muy alto":
              postion(0);
              break;
            case "Alto":
              postion(1);
              break;
            case "Medio":
              postion(2);
              break;
            case "Bajo":
              postion(3);
              break;
            case "Muy bajo":
              postion(4);
              break;
            default:
              datasets.push(d);
              break;
          }
          /*
            *
            * case 'Insatifacción muy alta':
                postion(0)
                break;
              case 'Insatifacción alta':
                postion(1)
                break;
              case 'Satifacción muy alta':
                postion(2)
                break;
              case 'Satifacción alta':
                postion(3)
                break;
              case 'Satifacción baja':
                postion(4)
                break;
            * */
        };

        data
          .filter((x) => x.SubGrupo)
          .map((x) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(
              x["countData"]["sum"],
              sumData
            );
            const rango = this.rangoFp(x.SubGrupo);
            d.data.push(porcentage);
            d.label = x.SubGrupo;
            d.backgroundColor.push(rango.color);
            d.borderColor.push(rango.border);

            orderData(d.label, d);
          });

        dataHorizontalBar.data.labels = [label];
        dataHorizontalBar.data.datasets = datasets.filter((x) => {
          if (x) return true;
        });

        this.graph = dataHorizontalBar;
        this.cambio++;
      }
    },
    rangoIntervencion() {
      const p = this.data.data;
      const type = this.data.data[0].Grupo === "RGO-09-Engagement" ? 1 : 0;
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = null;

        if (type === 0) {
          porcentageGroups = {
            alta1: {
              groups: ["Riesgo alto", "Riesgo muy alto", "Muy alto", "Alto"],
              sum: 0,
            },
            media: {
              groups: [
                "Riesgo medio",
                "Riesgo alto",
                "Riesgo muy alto",
                "Alto",
                "Muy Alto",
                "Medio",
              ],
              sum: 0,
            },
            destacado: {
              groups: [
                "Sin riesgo o riesgo despreciable",
                "Riesgo bajo",
                "Sin riesgo o riesgo bajo",
                "Factor protector",
                "Bajo",
                "Muy bajo",
              ],
              sum: 0,
            },
          };
        } else if (type === 1) {
          porcentageGroups = {
            alta1: {
              groups: ["Bajo", "Muy bajo"],
              sum: 0,
            },
            media: {
              groups: ["Bajo", "Muy bajo", "Medio"],
              sum: 0,
            },
            destacado: {
              groups: ["Muy alto", "Alto"],
              sum: 0,
            },
          };
        }

        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"].toFixed(2);

          if (k === "alta1" && porcentage >= 30.0) {
            this.porcentageG = porcentage;
            result = "bg-alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            this.porcentageG = porcentage;
            result = "bg-media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            this.porcentageG = porcentage;
            result = "bg-destacado";
            break;
          } else if (porcentage < 30.0) {
            this.porcentageG = porcentage;
            result = "bg-sinrango";
          }
        }
        this.titleBg = result;
      }
    },
    rangoFp(p) {
      const rangos = {
        rango0: [
          "Riesgo muy alto",
          "Insatisfacción muy alta",
          "Presentación muy alta de sintomas",
          "Muy alto",
        ], // muy alta
        rango1: [
          "Riesgo alto",
          "Insatisfacción alta",
          "Presentación alta de sintomas",
          "Alto",
        ], // alta
        rango2: [
          "Riesgo medio",
          "Satisfacción muy alta",
          "Presentación media de sintomas",
          "Medio",
        ], // medio
        rango3: [
          "Riesgo bajo",
          "Satisfacción alta",
          "Presentación baja de sintomas",
          "Bajo",
        ], // bajo
        rango4: [
          "Sin riesgo o riesgo despreciable",
          "Sin riesgo o riesgo bajo",
          "Satisfacción baja",
          "Presentación muy baja de sintomas o sin presencia de ellos",
          "Muy bajo",
        ], // sin riesgo o muy bajo
      };
      if (rangos.rango0.includes(p)) {
        return {
          color: "#f4cdcd",
          border: "#f6adad",
        };
      } else if (rangos.rango1.includes(p)) {
        return {
          color: "#facca5",
          border: "#f6b884",
        };
      } else if (rangos.rango2.includes(p)) {
        return {
          color: "#fff2cc",
          border: "#f6db8a",
        };
      } else if (rangos.rango3.includes(p)) {
        return {
          color: "#d9ead3",
          border: "#c3eab5",
        };
      } else if (rangos.rango4.includes(p)) {
        return {
          color: "#c8d9f7",
          border: "#a8c2ef",
        };
      } else {
        return {
          color: "#e1e1e1",
          border: "#c2c0c0",
        };
      }
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    getMeta(meta) {
      const metas = meta.split(".");
      const porcentage = parseFloat(this.porcentageG).toFixed(0);

      if (porcentage >= 30 && this.porcentageG <= 35) {
        meta = metas[0];
      } else if (porcentage >= 36 && this.porcentageG <= 50) {
        meta = metas[1];
      } else if (porcentage >= 51 && this.porcentageG <= 100) {
        meta = metas[2];
      }

      return meta + ".";
    },
    switchElement(ele) {
      this.elements[ele] = !this.elements[ele];
    },
    deleteEmptyElements(array) {
      return array.filter(function(el) {
        return !!el.length;
      });
    },
    close() {
      this.$emit("closeMenuInter");
    },
  },
  props: {
    data: Object,
  },
  created() {
    if (this.data) {
      this.createDataGraphHorizontalBar();
      this.rangoIntervencion();
    }
  },
  watch: {
    data(nv, ov) {
      this.createDataGraphHorizontalBar();
      this.rangoIntervencion();
    },
  },
};
</script>
<style lang="scss" scoped>
.message-body {
  height: 100%;
}
.menuInter {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow: scroll;
  border-radius: 0 0 0 0 !important;
}

.bg-muyAlto {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-alto {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-bajo {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-noRiesgo {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}

.bg-alta {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-media {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacado {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrango {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}

.border {
  border-radius: 10px;
}

ul {
  list-style: disc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuInterpretacion.vue